<ng-container formGroupName="nitrogenCalculationSettings">
  <div class="flex__child--auto">
    <div class="flex--column mat-slide-group-wrapper">
      @if (nitrogenCalculationSettingToggles?.shouldShowPreviousCropCornToggle) {
        <mat-slide-toggle
          color="primary"
          formControlName="isPreviousCropCorn"
          data-test="nitrogen-calculation-setting-previous-crop-corn"
          >{{ 'previousCropCorn' | translate }}</mat-slide-toggle
        >
      }
      @if (nitrogenCalculationSettingToggles?.shouldShowPreviousCropGrainToggle) {
        <mat-slide-toggle
          color="primary"
          formControlName="isPreviousCropNotGrain"
          data-test="nitrogen-calculation-setting-previous-crop-grain"
        >
          {{ 'previousCropNotGrain' | translate }}
        </mat-slide-toggle>
      }
      @if (nitrogenCalculationSettingToggles?.shouldShowShouldSplitNormToggle) {
        <mat-slide-toggle
          color="primary"
          formControlName="shouldSplitNorm"
          data-test="nitrogen-calculation-setting-split-rape-seed"
          >{{ 'splitRapeSeed' | translate }}</mat-slide-toggle
        >
      }
      @if (nitrogenCalculationSettingToggles?.shouldShowNitrogenDifferentiationToggle) {
        <mat-slide-toggle
          color="primary"
          formControlName="isNitrogenDifferentiation"
          data-test="nitrogen-calculation-setting-is-nitrogen-differentiation"
          >{{ 'nitrogenDifferentiation' | translate }}</mat-slide-toggle
        >
      }
      @if (nitrogenCalculationSettingToggles?.shouldShowAfterTornGrassToggle) {
        <mat-slide-toggle
          color="primary"
          formControlName="isAfterTornGrass"
          data-test="nitrogen-calculation-setting-after-torn-grass"
          >{{ 'afterTornGrass' | translate }}</mat-slide-toggle
        >
      }
      <mat-slide-toggle
        color="primary"
        formControlName="isRecoveryFertilisation"
        data-test="nitrogen-calculation-setting-recovery-fertilisation"
        >{{ 'recoveryFertilisationToggle' | translate }}</mat-slide-toggle
      >
    </div>
  </div>
</ng-container>
